import React, { useState, useEffect, useContext } from 'react';
import DashboardLayout from '../../components/DashboardLayout';
import DeviceWelcomePage from './DeviceWelcomePage';
import DeviceViewPage from './DeviceViewPage';
import { DevicesContext } from '../../contexts/DevicesContext';
import '../../styles/pages/device.css';
import { UserSelectedContext } from '../../contexts/UserSelectedContext';


const DevicesPage: React.FC = () => {
  /*User Selected Context*/
  const userSelectedContext = useContext(UserSelectedContext);
  if (!userSelectedContext) {
    throw new Error('useUserSelected must be used within a UserSelectedProvider');
  }
  const { showBottomBar, isBottomBarHidden } = userSelectedContext;


  const devicesContext = useContext(DevicesContext);
  if (!devicesContext) {
    throw new Error('useDevices must be used within a DevicesProvider');
  }
  const {
    devices,
    devicesForDashboard,
    parametersForDashboard,
    loading,
    getDevicesForDashboard,
    getParametersForDashboard,
    getUserDevices,
    getAqiInfoData
  } = devicesContext;
  const [hasDevices, setHasDevices] = useState<boolean | null>(null);

  useEffect(() => {
    const checkDevices = async () => {
      try {
        // First check if we already have user's own devices in state
        if (devices && devices.length > 0) {
          console.log('Using existing devices from state:', devices);
          if (devicesForDashboard.length <= 0) await getDevicesForDashboard();
          if (parametersForDashboard.length <= 0) await getParametersForDashboard();
          setHasDevices(true);
          return;
        }

        // Only call API if we don't have devices in state
        console.log('No devices in state, calling API...');
        await getDevicesForDashboard();
        await getParametersForDashboard();
        const userDevices = await getUserDevices();
        await getAqiInfoData();
        // Use userDevices (user's own devices) to decide welcome vs view page
        // devicesForDashboard may include demo device, so we check userDevices instead
        setHasDevices(userDevices.length > 0);
      } catch (error) {
        console.error('Error checking devices:', error);
        // If there's an error, default to showing welcome page
        setHasDevices(false);
      }
    };

    checkDevices();

  }, []); // Remove devicesForDashboard from dependency array

  // Function to show device table with demo device
  const handleShowTableWithDemoDevice = () => {
    setHasDevices(true);
  };

  /*unhide bottom bar*/
  useEffect(() => {
    if (window.innerWidth <= 768 && isBottomBarHidden) {
      showBottomBar();
    }
  }, []);

  // Show loading state while checking devices
  if (loading || hasDevices === null) {
    return (
      <DashboardLayout>
        <div className="h-[calc(100dvh-2rem)] loading-container">
          <div className="h-8 w-8 border-b-2 border-[var(--gradient-button-left-color)] mb-4 animate-spin rounded-full"></div>
          <p className="text-base text-[var(--color-sub-title-text)]">Loading devices...</p>
        </div>
      </DashboardLayout>
    );
  }

  // // Show error state if API call failed
  // if (error) {
  //   return (
  //     <DashboardLayout>
  //       <div className="error-container">
  //         <p>Error loading devices: {error}</p>
  //         <button onClick={() => window.location.reload()}>Retry</button>
  //       </div>
  //     </DashboardLayout>
  //   );
  // }

  // Render appropriate page based on device status
  if (hasDevices) {
    return <DeviceViewPage />;
  } else {
    return <DeviceWelcomePage showDeviceTable={handleShowTableWithDemoDevice} />;
  }
};

export default DevicesPage;
